import { useState, useEffect } from 'react';
import styles from './OfferLoadingScreen.module.css';

const PHRASES = [
  'Exploring database',
  'Compiling options',
  'Searching medications',
  'Analyzing your profile',
  'Finding best matches'
];

const TOTAL_DURATION = 5000;
const PHRASE_DURATION = TOTAL_DURATION / PHRASES.length;

const OfferLoadingScreen = ({ onComplete }) => {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPhraseIndex((prev) => {
        const next = prev + 1;
        if (next >= PHRASES.length) {
          clearInterval(interval);
        }
        return next;
      });
    }, PHRASE_DURATION);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete?.();
    }, TOTAL_DURATION);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const currentPhrase = PHRASES[Math.min(phraseIndex, PHRASES.length - 1)];
  const words = currentPhrase.split(' ');
  const firstWord = words[0];
  const restWords = words.slice(1).join(' ');

  return (
    <div className={styles.screen}>
      <div className={styles.content}>
        <p className={styles.subtitle}>We have got you covered</p>
        <h1 key={phraseIndex} className={styles.headline}>
          <span className={styles.orangeWord}>{firstWord}</span>{' '}
          {restWords}
        </h1>
      </div>
    </div>
  );
};

export { PHRASES, TOTAL_DURATION, PHRASE_DURATION };
export default OfferLoadingScreen;
